import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import bookOverview from '../../../types/BookOverviewType';
import BookImage from '../../01_atoms/BookImage/BookImage';
import EditButton from '../../01_atoms/EditButton/EditButton';
import ReaderBanner from '../../01_atoms/ReaderBanner/ReaderBanner';
import TextLabel from '../../01_atoms/TextLabel/TextLabel';

interface BookOverviewItemProps {
  status: string;
  data: bookOverview;
  admin?: boolean;
  displayName?: string | null;
}

function BookOverviewItem(props: Readonly<BookOverviewItemProps>) {
  const { status, data, admin, displayName } = props;
  const navigate = useNavigate();

  const navigateToBook = useCallback(() => {
    if (admin) {
      navigate('/admin/detail', { state: data });
    } else {
      navigate('/detail', { state: data });
    }
  }, [admin, data, navigate]);

  return (
    <article className="m-book-overview-item__container">
      <button
        type='button'
        className="m-book-overview-button"
        onClick={navigateToBook}
      >
        <div className="m-book-overview-item__image">
          {admin && <EditButton data={data} />}
          <BookImage title={data.title} status={status} url={data.coverBookUrl} />
          {displayName && displayName !== '' ? <ReaderBanner displayName={displayName} /> : null}
        </div>
        <TextLabel text={data.title} size="medium" />
        <TextLabel text={data.author} size="small" />
      </button>
    </article>
  );
}

BookOverviewItem.defaultProps = {
  admin: false,
  displayName: null,
};

export default BookOverviewItem;

